import React from 'react';
import PropTypes from 'prop-types';
const forwardArrow = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg"
    width="7.041"
    height="10.915"
    viewBox="0 0 7.041 10.915"
>
    <path
        id="_copy"
        data-name=" copy"
        d="M6.758,10.671c.7-.643-.039-1.412-.735-2.061L2.638,5.456,6.756,1.638a1.048,1.048,0,0,0,0-1.392h0a1.258,1.258,0,0,0-1.5,0L.232,4.934a.7.7,0,0,0,0,1.044l5.037,4.693a1.257,1.257,0,0,0,1.49,0Z"
        transform="translate(7.041 10.915) rotate(180)"
        fill={fill || "#6F6F6F"}
    />
</svg>

);

forwardArrow.prototype = {
    width: PropTypes.number,
    height: PropTypes.number

};

export default forwardArrow;